import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import LocalizedNavLink from '../router/LocalizedNavLink';

import './Breadcrumb.scss';

class Breadcrumb extends React.Component {
    render() {
        const { routes, defaultRoute, cssClass, BRAND_NAME, i18nAccessibility } = this.props;

        return (
            <MediaQuery query="(min-width: 768px)">
                {matches =>
                    matches ? (
                        <nav
                            id="breadcrumb"
                            className={cssClass}
                            aria-label={i18nAccessibility.BREADCRUMB_LABEL}>
                            <ol>
                                {defaultRoute && (
                                    <li>
                                        <LocalizedNavLink
                                            to={PATH.HOME_PATH}
                                            title={`${i18nAccessibility.BREADCRUMB_HOME_TITLE} - ${BRAND_NAME}`}
                                            exact>
                                            {BRAND_NAME}
                                        </LocalizedNavLink>
                                    </li>
                                )}
                                {routes.map((r, i, routes) => (
                                    <li key={i}>
                                        <LocalizedNavLink
                                            to={r.route}
                                            title={r.label}
                                            key={r.label}
                                            className={routes.length - 1 === i ? 'last' : ''}
                                            exact>
                                            {r.label}
                                        </LocalizedNavLink>
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    ) : (
                        <div style={{ marginTop: '40px' }} />
                    )
                }
            </MediaQuery>
        );
    }
}

Breadcrumb.propTypes = {
    routes: PropTypes.array,
    defaultRoute: PropTypes.bool,
    cssClass: PropTypes.string
};

const mapStateToProps = state => {
    return {
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        i18nAccessibility: state.i18n.common.ACCESSIBILITY
    };
};

export default connect(mapStateToProps)(Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/breadcrumb/Breadcrumb.js